import script from "./KonamiEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./KonamiEffect.vue?vue&type=script&setup=true&lang=js"

import "./KonamiEffect.vue?vue&type=style&index=0&id=26b7dfd0&lang=scss"

const __exports__ = script;

export default __exports__